import { useContext } from 'react';
import { LocalizationContext, } from './localizationContext';
export var useLanguage = function () {
    var _a = useContext(LocalizationContext), t = _a.t, setLocale = _a.setLocale, locale = _a.locale, formatNumber = _a.formatNumber;
    return [t, setLocale, locale, formatNumber];
};
